import { render, staticRenderFns } from "./Vertical.vue?vue&type=template&id=3a3e14c9&scoped=true&"
import script from "./Vertical.vue?vue&type=script&lang=js&"
export * from "./Vertical.vue?vue&type=script&lang=js&"
import style0 from "./Vertical.vue?vue&type=style&index=0&id=3a3e14c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e14c9",
  null
  
)

export default component.exports